import * as React from "react";
import { DatePicker, List, Toast, Tabs } from "antd-mobile";
import styles from "./index.module.css";
import { request } from "../../services";
import { copyright } from "../../utils/copyright";
import { getParam } from "../../utils/getParam";
import { formatDate, doFormatDate } from "../../utils/formatDate";
import { doShare, doChangeTitle } from "../../utils/share";

import Zoumadeng from "../../components/Zoumadeng";
import Liebiao from "../../components/Liebiao";

interface Props {}
interface State {
  date: Date;
  type: string;
  year: string;
  month: string;
  day: string;
  maxDate: Date;
  share_title: string;
  share_sub_title: string;
  share_image: string;
  selectedTab: string;
  baozhi_info: any[];
  curTab: number;
  curIndex: number;
}

const tabs2 = [
  { title: "版面", sub: "1" },
  { title: "列表", sub: "2" }
];

class Index extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const month = getParam("month");
    const year = getParam("year");
    const day = getParam("day");
    let curIndex = parseInt(getParam("page"), 10) || 0;
    // console.log(curIndex);

    this.state = {
      date: new Date(formatDate(year), formatDate(month) - 1, formatDate(day)),
      type: getParam("type"),
      month,
      year,
      day,
      maxDate: new Date(),
      share_title: "",
      share_sub_title: "",
      share_image: "",
      selectedTab: "redTab",
      baozhi_info: [],
      curTab: 0,
      curIndex
    };

    // this.getPaperContent = this.getPaperContent.bind(this);
    this.getPaperPageList = this.getPaperPageList.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onGoToTab = this.onGoToTab.bind(this);
  }

  componentDidMount() {
    document.title = doChangeTitle(this.state.type);
    copyright();
    Toast.loading("Loading...", 0);
    this.getPaperPageList();
  }

  async getPaperPageList() {
    const data = {
      type: this.state.type,
      year: this.state.year,
      month: this.state.month,
      day: this.state.day
    };
    const type: number = 1;

    try {
      let res = await request(data, type);

      if (res.code === 1) {
        if (res.data.baozhi_info.length) {
          Toast.info(res.msg, 1);
        } else {
          Toast.fail("无内容，请切换其他日期");
        }

        const data = res.data;

        const max_date = data.baozhi_max_date;

        document.title = data.share_title;

        this.setState((prevState, props) => ({
          maxDate: new Date(
            formatDate(max_date.year),
            formatDate(max_date.month) - 1,
            formatDate(max_date.day)
          ),
          share_image: data.share_image,
          share_sub_title: data.share_sub_title,
          share_title: data.share_title,
          baozhi_info: data.baozhi_info
        }));

        let shareData = data;

        if (this.state.curIndex !== 0) {
          shareData.share_title = data.baozhi_info[this.state.curIndex].title;
        }

        if (navigator.userAgent.indexOf("MicroMessenger") >= 0) {
          doShare(shareData);
        } else {
          let fdata = {
            title: shareData.share_title,
            image: shareData.share_image,
            content: shareData.share_sub_title,
            url: `${window.location.href.split("&page")[0]}&page=${0}`
          };
          console.log(window.share_ini);
          window.share_ini(fdata);
        }
      } else {
        Toast.fail(res.msg, 1);
      }
    } catch (error) {
      // throw new Error(error);
    }
  }

  onChangeDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const baseUrl = window.location.href.split("year")[0];

    const url = `${baseUrl}year=${year}&month=${doFormatDate(
      month
    )}&day=${doFormatDate(day)}`;

    window.location.href = url;
  }

  onGoToTab(index: number) {
    // console.log(index);
    this.setState((prevState, props) => ({
      // curTab: 0,
      curIndex: index
    }));
  }

  onInitSwitchSlide() {
    // this.setState;
  }

  render() {
    return (
      <div className={styles.Index}>
        <List
          className={styles.DatePicker}
          style={{ backgroundColor: "white" }}
        >
          <DatePicker
            mode="date"
            title="选择日期"
            extra="Optional"
            value={this.state.date}
            maxDate={this.state.maxDate}
            onChange={date => this.onChangeDate(date)}
          >
            <List.Item arrow="horizontal">日期</List.Item>
          </DatePicker>
        </List>
        <div className={styles.Tabs}>
          <Tabs
            tabs={tabs2}
            initialPage={1}
            page={this.state.curTab}
            tabBarPosition="bottom"
            renderTab={tab => <span>{tab.title}</span>}
            swipeable={false}
            onTabClick={(tab: any, index: number) => {
              this.setState({ curTab: index });
            }}
          >
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                height: "100%",
                backgroundColor: "#fff"
              }}
            >
              <Zoumadeng
                baozhi_info={this.state.baozhi_info}
                curIndex={this.state.curIndex}
                baseImg={this.state.share_image}
                baseContent={this.state.share_sub_title}
              />
            </div>
            <div
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "center",
                height: "100%",
                backgroundColor: "#fff"
              }}
            >
              <Liebiao
                baozhi_info={this.state.baozhi_info}
                onGoToTab={this.onGoToTab}
              />
            </div>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default Index;
